import styled from 'styled-components';

import { mediaQueriesNew } from 'theme/mediaQueries';

export const LoginForm = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 432px;
    width: 100%;
    margin: 0 auto;
    padding: 16px 16px 32px;

    ${mediaQueriesNew.tablet} {
        padding-top: 235px;
        padding-bottom: 60px;
    }
    ${mediaQueriesNew.desktop} {
        padding-top: 8px;
        padding-bottom: 64px;
        justify-content: center;
        max-width: 375px;
    }
`;

export const LoginEmailInput = styled.div`
    ${mediaQueriesNew.tablet} {
        padding-top: 8px;
    }
`;
